import { createAction, props } from '@ngrx/store';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import {
  PostedFlightSkeleton,
  PagedPostedFlightAudit,
  PagedLogbookApproachAudit,
  PagedFlightPassengerAudit,
  PagedExpenseAudit,
  PagedPostedFlightEngineAudit,
  PagedPostedFlightComponentAudit,
  PagedPostedFlightFuelAudit,
  PagedPostedFlightAdditionalDetailAudit,
  PagedPostedFlightDeAntiIceAudit,
  PagedEngineOilFluidAudit,
  PagedComponentOilFluidAudit,
  PagedOilFluidAudit,
  PagedFuelUpliftAudit,
  PagedLogbookAudit,
  PagedDepartmentAudit,
  PagedBusinessCategoryAudit,
  PagedCrewMemberDutyAudit,
  PagedAirFrameLandingsAudit,
  PagedEngineCyclesAudit,
  PagedVORCheckDataAudit,
  PreFlightChecklistUserESignaturesAudit,
  PostedFlightChecklistUserESignaturesAudit,
  FlightLogUserESignaturesAudit,
  SquawkUserESignaturesAudit
} from '../../+models/posted-flight.audit.model';
import {
  PagedFlightBusinessPersonAudit,
  PagedFlightCrewMemberAudit
} from '../../+models/trip-audit.model';

export const ResetPostedFlight = createAction('[SharedAudit PostedFlight] Reset');

export const LoadApproachTypes = createAction('[SharedAudit PostedFlight] Load Approach Types');

export const ApproachTypesLoaded = createAction(
  '[SharedAudit PostedFlight] Approach Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const ApproachTypesLoadError = createAction(
  '[SharedAudit PostedFlight] Approach Types Load Error',
  props<{ err: any }>()
);

export const LoadExpenseCategoryTypes = createAction(
  '[SharedAudit PostedFlight] Load ExpenseCategory Types'
);

export const ExpenseCategoryTypesLoaded = createAction(
  '[SharedAudit PostedFlight] ExpenseCategory Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const ExpenseCategoryTypesLoadError = createAction(
  '[SharedAudit PostedFlight] ExpenseCategory Types Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightSkeleton = createAction(
  '[SharedAudit PostedFlight] Load PostedFlight Skeleton'
);

export const PostedFlightSkeletonLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlight Skeleton Loaded',
  props<{ payload: PostedFlightSkeleton }>()
);

export const PostedFlightSkeletonLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlight Skeleton Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlight Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlight Audit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlight Audit Loaded',
  props<{ postedFlightId: number; audits: PagedPostedFlightAudit }>()
);

export const PostedFlightAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlight Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightCrewMemberAudit = createAction(
  '[SharedAudit PostedFlight] Load FlightCrewMember Audit',
  props<{ flightCrewMemberId: number }>()
);

export const LoadNextPageFlightCrewMemberAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage FlightCrewMember Audit',
  props<{ flightCrewMemberId: number }>()
);

export const FlightCrewMemberAuditLoaded = createAction(
  '[SharedAudit PostedFlight] FlightCrewMember Audit Loaded',
  props<{ flightCrewMemberId: number; audits: PagedFlightCrewMemberAudit }>()
);

export const FlightCrewMemberAuditLoadError = createAction(
  '[SharedAudit PostedFlight] FlightCrewMember Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightBusinessPersonAudit = createAction(
  '[SharedAudit PostedFlight] Load FlightBusinessPerson Audit',
  props<{ flightBusinessPersonId: number }>()
);

export const LoadNextPageFlightBusinessPersonAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage FlightBusinessPerson Audit',
  props<{ flightBusinessPersonId: number }>()
);

export const FlightBusinessPersonAuditLoaded = createAction(
  '[SharedAudit PostedFlight] FlightBusinessPerson Audit Loaded',
  props<{ flightBusinessPersonId: number; audits: PagedFlightBusinessPersonAudit }>()
);

export const FlightBusinessPersonAuditLoadError = createAction(
  '[SharedAudit PostedFlight] FlightBusinessPerson Audit Load Error',
  props<{ err: any }>()
);

export const LoadLogbookApproachAudit = createAction(
  '[SharedAudit PostedFlight] Load LogbookApproach Audit',
  props<{ logbookApproachId: number }>()
);

export const LoadNextPageLogbookApproachAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage LogbookApproach Audit',
  props<{ logbookApproachId: number }>()
);

export const LogbookApproachAuditLoaded = createAction(
  '[SharedAudit PostedFlight] LogbookApproach Audit Loaded',
  props<{ logbookApproachId: number; audits: PagedLogbookApproachAudit }>()
);

export const LogbookApproachAuditLoadError = createAction(
  '[SharedAudit PostedFlight] LogbookApproach Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightPassengerAudit = createAction(
  '[SharedAudit PostedFlight] Load FlightPassenger Audit',
  props<{ flightPassengerId: number }>()
);

export const LoadNextPageFlightPassengerAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage FlightPassenger Audit',
  props<{ flightPassengerId: number }>()
);

export const FlightPassengerAuditLoaded = createAction(
  '[SharedAudit PostedFlight] FlightPassenger Audit Loaded',
  props<{ flightPassengerId: number; audits: PagedFlightPassengerAudit }>()
);

export const FlightPassengerAuditLoadError = createAction(
  '[SharedAudit PostedFlight] FlightPassenger Audit Load Error',
  props<{ err: any }>()
);

export const LoadExpenseAudit = createAction(
  '[SharedAudit PostedFlight] Load Expense Audit',
  props<{ expenseId: number }>()
);

export const LoadNextPageExpenseAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage Expense Audit',
  props<{ expenseId: number }>()
);

export const ExpenseAuditLoaded = createAction(
  '[SharedAudit PostedFlight] Expense Audit Loaded',
  props<{ expenseId: number; audits: PagedExpenseAudit }>()
);

export const ExpenseAuditLoadError = createAction(
  '[SharedAudit PostedFlight] Expense Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightEngineAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightEngine Audit',
  props<{ postedFlightEngineId: number }>()
);

export const LoadNextPagePostedFlightEngineAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightEngine Audit',
  props<{ postedFlightEngineId: number }>()
);

export const PostedFlightEngineAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightEngine Audit Loaded',
  props<{ postedFlightEngineId: number; audits: PagedPostedFlightEngineAudit }>()
);

export const PostedFlightEngineAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightEngine Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightComponentAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightComponent Audit',
  props<{ postedFlightComponentId: number }>()
);

export const LoadNextPagePostedFlightComponentAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightComponent Audit',
  props<{ postedFlightComponentId: number }>()
);

export const PostedFlightComponentAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightComponent Audit Loaded',
  props<{ postedFlightComponentId: number; audits: PagedPostedFlightComponentAudit }>()
);

export const PostedFlightComponentAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightComponent Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightFuelAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightFuel Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightFuelAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightFuel Audit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightFuelAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightFuel Audit Loaded',
  props<{ postedFlightId: number; audits: PagedPostedFlightFuelAudit }>()
);

export const PostedFlightFuelAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightFuel Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightAdditionalDetailAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightAdditionalDetail Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightAdditionalDetailAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightAdditionalDetail Audit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightAdditionalDetailAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightAdditionalDetail Audit Loaded',
  props<{ postedFlightId: number; audits: PagedPostedFlightAdditionalDetailAudit }>()
);

export const PostedFlightAdditionalDetailAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightAdditionalDetail Audit Load Error',
  props<{ err: any }>()
);

export const LoadOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load OilFluid Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPageOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage OilFluid Audit',
  props<{ postedFlightId: number }>()
);

export const OilFluidAuditLoaded = createAction(
  '[SharedAudit PostedFlight] OilFluid Audit Loaded',
  props<{ postedFlightId: number; audits: PagedOilFluidAudit }>()
);

export const OilFluidAuditLoadError = createAction(
  '[SharedAudit PostedFlight] OilFluid Audit Load Error',
  props<{ err: any }>()
);

export const LoadEngineOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load EngineOilFluid Audit',
  props<{ postedFlightEngineId: number }>()
);

export const LoadNextPageEngineOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage EngineOilFluid Audit',
  props<{ postedFlightEngineId: number }>()
);

export const EngineOilFluidAuditLoaded = createAction(
  '[SharedAudit PostedFlight] EngineOilFluid Audit Loaded',
  props<{ postedFlightEngineId: number; audits: PagedEngineOilFluidAudit }>()
);

export const EngineOilFluidAuditLoadError = createAction(
  '[SharedAudit PostedFlight] EngineOilFluid Audit Load Error',
  props<{ err: any }>()
);

export const LoadComponentOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load ComponentOilFluid Audit',
  props<{ postedFlightComponentId: number }>()
);

export const LoadNextPageComponentOilFluidAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage ComponentOilFluid Audit',
  props<{ postedFlightComponentId: number }>()
);

export const ComponentOilFluidAuditLoaded = createAction(
  '[SharedAudit PostedFlight] ComponentOilFluid Audit Loaded',
  props<{
    postedFlightComponentId: number;
    audits: PagedComponentOilFluidAudit;
  }>()
);

export const ComponentOilFluidAuditLoadError = createAction(
  '[SharedAudit PostedFlight] ComponentOilFluid Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightDeAntiIceAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightDeAntiIce Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightDeAntiIceAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightDeAntiIce Audit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightDeAntiIceAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightDeAntiIce Audit Loaded',
  props<{ postedFlightId: number; audits: PagedPostedFlightDeAntiIceAudit }>()
);

export const PostedFlightDeAntiIceAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightDeAntiIce Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedFlightNotesAudit = createAction(
  '[SharedAudit PostedFlight] Load PostedFlightNotes Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightNotesAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage PostedFlightNotes Audit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightNotesAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightNotes Audit Loaded',
  props<{ postedFlightId: number; audits: PagedPostedFlightDeAntiIceAudit }>()
);

export const PostedFlightNotesAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightNotes Audit Load Error',
  props<{ err: any }>()
);

export const LoadFuelUpliftAudit = createAction(
  '[SharedAudit PostedFlight] Load FuelUplift Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPageFuelUpliftAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage FuelUplift Audit',
  props<{ postedFlightId: number }>()
);

export const FuelUpliftAuditLoaded = createAction(
  '[SharedAudit PostedFlight] FuelUplift Audit Loaded',
  props<{ postedFlightId: number; audits: PagedFuelUpliftAudit }>()
);

export const FuelUpliftAuditLoadError = createAction(
  '[SharedAudit PostedFlight] FuelUplift Audit Load Error',
  props<{ err: any }>()
);

export const LoadBusinessCategoryAudit = createAction(
  '[SharedAudit PostedFlight] Load BusinessCategory Audit',
  props<{ flightId: number }>()
);

export const LoadNextPageBusinessCategoryAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage BusinessCategory Audit',
  props<{ flightId: number }>()
);

export const BusinessCategoryAuditLoaded = createAction(
  '[SharedAudit PostedFlight] BusinessCategory Audit Loaded',
  props<{ flightId: number; audits: PagedBusinessCategoryAudit }>()
);

export const BusinessCategoryAuditLoadError = createAction(
  '[SharedAudit PostedFlight] BusinessCategory Audit Load Error',
  props<{ err: any }>()
);

export const LoadDepartmentAudit = createAction(
  '[SharedAudit PostedFlight] Load Department Audit',
  props<{ flightId: number }>()
);

export const LoadNextPageDepartmentAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage Department Audit',
  props<{ flightId: number }>()
);

export const DepartmentAuditLoaded = createAction(
  '[SharedAudit PostedFlight] Department Audit Loaded',
  props<{ flightId: number; audits: PagedDepartmentAudit }>()
);

export const DepartmentAuditLoadError = createAction(
  '[SharedAudit PostedFlight] Department Audit Load Error',
  props<{ err: any }>()
);

export const LoadLogbookAudit = createAction(
  '[SharedAudit PostedFlight] Load Logbook Audit',
  props<{ logbookId: number }>()
);

export const LoadNextPageLogbookAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage Logbook Audit',
  props<{ logbookId: number }>()
);

export const LogbookAuditLoaded = createAction(
  '[SharedAudit PostedFlight] Logbook Audit Loaded',
  props<{ logbookId: number; audits: PagedLogbookAudit }>()
);

export const LogbookAuditLoadError = createAction(
  '[SharedAudit PostedFlight] Logbook Audit Load Error',
  props<{ err: any }>()
);

export const LoadCrewMemberDutyAudit = createAction(
  '[SharedAudit PostedFlight] Load CrewMemberDuty Audit',
  props<{ crewMemberDutyId: number }>()
);

export const LoadNextPageCrewMemberDutyAudit = createAction(
  '[SharedAudit PostedFlight] Load NextPage CrewMemberDuty Audit',
  props<{ crewMemberDutyId: number }>()
);

export const CrewMemberDutyAuditLoaded = createAction(
  '[SharedAudit PostedFlight] CrewMemberDuty Audit Loaded',
  props<{ crewMemberDutyId: number; audits: PagedCrewMemberDutyAudit }>()
);

export const CrewMemberDutyAuditLoadError = createAction(
  '[SharedAudit PostedFlight] CrewMemberDuty Audit Load Error',
  props<{ err: any }>()
);

export const LoadAirFrameLandingsAuditAction = createAction(
  '[SharedAudit PostedFlight] Load Airframe Audit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPageAirFrameLandingsAuditAction = createAction(
  '[SharedAudit PostedFlight] Load NextPage Airframe Audit',
  props<{ postedFlightId: number }>()
);

export const AirFrameLandingsAuditLoadedAction = createAction(
  '[SharedAudit PostedFlight] AirFrame Audit Loaded',
  props<{ postedFlightId: number; audits: PagedAirFrameLandingsAudit }>()
);

export const AirFrameLandingsAuditLoadErrorAction = createAction(
  '[SharedAudit PostedFlight] AirFrame Audit Load Error',
  props<{ err: any }>()
);

export const LoadEngineCyclesAuditAction = createAction(
  '[SharedAudit PostedFlight] Load EngineCycles Audit',
  props<{ postedFlightEngineId: number }>()
);

export const LoadNextPageEngineCyclesAuditAction = createAction(
  '[SharedAudit PostedFlight] Load NextPage EngineCycles Audit',
  props<{ postedFlightEngineId: number }>()
);

export const EngineCyclesAuditLoadedAction = createAction(
  '[SharedAudit PostedFlight] EngineCycles Audit Loaded',
  props<{ postedFlightEngineId: number; audits: PagedEngineCyclesAudit }>()
);

export const EngineCyclesAuditLoadErrorAction = createAction(
  '[SharedAudit PostedFlight] EngineCycles Audit Load Error',
  props<{ err: any }>()
);

export const LoadVORCheckDataAuditAction = createAction(
  '[SharedAudit PostedFlight] Load VORCheck Data Audit',
  props<{ aircraftProfileId: number }>()
);

export const LoadNextPageVORCheckDataAuditAction = createAction(
  '[SharedAudit PostedFlight] Load NextPage VORCheck Data Audit',
  props<{ aircraftProfileId: number }>()
);

export const VORCheckDataAuditLoadedAction = createAction(
  '[SharedAudit PostedFlight] VORCheck Data Audit Loaded',
  props<{ aircraftProfileId: number; audits: PagedVORCheckDataAudit }>()
);

export const VORCheckDataAuditLoadErrorAction = createAction(
  '[SharedAudit PostedFlight] VORCheck Data Audit Load Error',
  props<{ err: any }>()
);

export const LoadPreFlightChecklistUserESignaturesAudit = createAction(
  '[SharedAudit PreFlight] LoadPreFlightChecklistUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePreFlightChecklistUserESignaturesAudit = createAction(
  '[SharedAudit PreFlight] LoadNextPagePreFlightChecklistUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const PreFlightChecklistUserESignaturesAuditLoaded = createAction(
  '[SharedAudit PreFlight] PreFlightChecklistUserESignaturesAuditLoaded',
  props<{ postedFlightId: number; audits: PreFlightChecklistUserESignaturesAudit }>()
);

export const PreFlightChecklistUserESignaturesAuditLoadError = createAction(
  '[SharedAudit PreFlight] PreFlightChecklistUserESignaturesAuditLoadError',
  props<{ err: any }>()
);

export const LoadPostedFlightChecklistUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadPostedFlightChecklistUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPagePostedFlightChecklistUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadNextPagePostedFlightChecklistUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const PostedFlightChecklistUserESignaturesAuditLoaded = createAction(
  '[SharedAudit PostedFlight] PostedFlightChecklistUserESignaturesAuditLoaded',
  props<{ postedFlightId: number; audits: PostedFlightChecklistUserESignaturesAudit }>()
);

export const PostedFlightChecklistUserESignaturesAuditLoadError = createAction(
  '[SharedAudit PostedFlight] PostedFlightChecklistUserESignaturesAuditLoadError',
  props<{ err: any }>()
);

export const LoadFlightLogUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadFlightLogUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPageFlightLogUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadNextPageFlightLogESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const FlightLogUserESignaturesAuditLoaded = createAction(
  '[SharedAudit PostedFlight] FlightLogUserESignaturesAuditLoaded',
  props<{ postedFlightId: number; audits: FlightLogUserESignaturesAudit }>()
);

export const FlightLogUserESignaturesAuditLoadError = createAction(
  '[SharedAudit PostedFlight] FlightLogUserESignaturesAuditLoadError',
  props<{ err: any }>()
);

export const LoadSquawkUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadSquawkUserESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const LoadNextPageSquawkUserESignaturesAudit = createAction(
  '[SharedAudit PostedFlight] LoadNextPageSquawkESignaturesAudit',
  props<{ postedFlightId: number }>()
);

export const SquawkUserESignaturesAuditLoaded = createAction(
  '[SharedAudit PostedFlight] SquawkUserESignaturesAuditLoaded',
  props<{ postedFlightId: number; audits: SquawkUserESignaturesAudit }>()
);

export const SquawkUserESignaturesAuditLoadError = createAction(
  '[SharedAudit PostedFlight] SquawkUserESignaturesAuditLoadError',
  props<{ err: any }>()
);
